<template>
  <main>
    <SingleLevelBreadcrumb label="Allgemeine Geschäftsbedingungen" />

    <GridContainer padding>
      <Heading
        class="text--center"
        spaces-bottom
      >
        Allgemeine Geschäftsbedingungen
      </Heading>
      <Paragraph class="text--center">
        Allgemeine Geschäftsbedingungen der Brodos AG für den Onlineshop www.shop.telekom.de
      </Paragraph>

      <template v-for="(paragraph, i) in paragraphs">
        <div :key="i">
          <Heading
            tag="h2"
            size="sm"
            spaces-bottom
            v-html="paragraph.headline"
          />
          <Paragraph v-html="paragraph.text" />
          <div v-if="i === 2">
            <div>
              <h3 class="text text--center text--bold text--h5">Widerrufsbelehrung</h3>
              <h4 class="text--h5">Widerrufsrecht</h4>
              <p>
                Du hast das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu
                widerrufen.<br /><br />Die Widerrufsfrist beträgt vierzehn Tage, ab dem Tag, an dem
                Du oder ein von Dir benannter Dritter, der nicht der Beförderer ist, die Waren in
                Besitz genommen hast bzw. hat.<br /><br />Im Falle eines Vertrags über mehrere
                Waren, die Du im Rahmen einer einheitlichen Bestellung bestellt hast und die
                getrennt geliefert werden, beträgt die Widerrufsfrist vierzehn Tage ab dem Tag, an
                dem Du oder ein von Dir benannter Dritter, der nicht der Beförderer ist, die letzte
                Ware in Besitz genommen hast bzw. hat.<br /><br />Im Falle eines Vertrags über die
                Lieferung einer Ware in mehreren Teilsendungen oder Stücken, beträgt die
                Widerrufsfrist vierzehn Tage ab dem Tag, an dem Du oder ein von Dir benannter
                Dritter, der nicht der Beförderer ist, die letzte Teilsendung oder das letzte Stück
                in Besitz genommen hast bzw. hat.<br /><br />Im Falle eines Vertrags zur
                regelmäßigen Lieferung von Waren über einen festgelegten Zeitraum hinweg beträgt die
                Widerrufsfrist vierzehn Tage ab dem Tag, an dem Du oder ein von Dir benannter
                Dritter, der nicht der Beförderer ist, die erste Ware in Besitz genommen hast bzw.
                hat.<br /><br />Um Dein Widerrufsrecht auszuüben, musst Du uns, der<br /><br />Brodos
                AG<br />Erlanger Straße 9-13<br />D-91083 Baiersdorf<br />E-Mail
                <a
                  href="mailto:telekom-onlineshop-service@brodos.de"
                  title="Telekom Onlineshop Service"
                  class="link"
                  target="_blank"
                  rel="noopener"
                  data-tealium-rel="content.text.telekom-onlineshop-service"
                  >telekom-onlineshop-service@brodos.de</a
                ><br />Telefax 09133 47995-2000<br />Telefon 09133 6084 -350<br /><br /><br />mittels
                einer eindeutigen Erklärung (z.B. über unser Rücksendeformular
                <a
                  href="https://service.brodos.net/retoure"
                  title="Brodos Retoure"
                  class="link link--external"
                  target="_blank"
                  rel="noopener"
                  data-tealium-rel="content.text.brodos-retoure"
                  >https://service.brodos.net/retoure</a
                >, ein mit der Post versandter Brief, Telefax oder E-Mail) über Deinen Entschluss,
                diesen Vertrag zu widerrufen, informieren. Du kannst dafür das beigefügte
                Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.<br /><br />Zur
                Wahrung der Widerrufsfrist reicht es aus, dass Du die Mitteilung über die Ausübung
                des Widerrufsrechts vor Ablauf der Widerrufsfrist absendest.<br /><br />
              </p>
              <h4 class="text text--bold text--h5">Folgen des Widerrufs</h4>
              <br /><br />
              Wenn Du diesen Vertrag widerrufst, haben wir Dir alle Zahlungen, die wir von Dir
              erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten,
              die sich daraus ergeben, dass Du eine andere Art der Lieferung als die von uns
              angebotene, günstigste Standardlieferung gewählt hast), unverzüglich und spätestens
              binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Deinen
              Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir
              dasselbe Zahlungsmittel, das Du bei der ursprünglichen Transaktion eingesetzt hast, es
              sei denn, mit Dir wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
              Dir wegen dieser Rückzahlung Entgelte berechnet. <br /><br />Wir können die
              Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Du den
              Nachweis erbracht hast, dass Du die Waren zurückgesandt hast, je nachdem, welches der
              frühere Zeitpunkt ist. <br /><br />Du hast die Waren unverzüglich und in jedem Fall
              spätestens binnen vierzehn Tagen ab dem Tag, an dem Du uns über den Widerruf dieses
              Vertrages unterrichtest, an uns zurückzusenden oder zu übergeben. Die Frist ist
              gewahrt, wenn Du die Waren vor Ablauf der Frist von vierzehn Tagen absendest.<br /><br />Wir
              tragen die unmittelbaren Kosten der Rücksendung der Waren.<br /><br />Du musst für
              einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen
              zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht
              notwendigen Umgang mit ihnen zurückzuführen ist.<br /><br />
              <h4 class="text text--bold text--h5">Erlöschensgründe</h4>
              <br /><br />
              Das Widerrufsrecht erlischt bei einem Vertrag über die Bereitstellung von nicht auf
              einem körperlichen Datenträger befindlichen digitalen Inhalten, der den Verbraucher
              zur Zahlung eines Preises verpflichtet, wenn der Verbraucher:
              <ul class="list">
                <li class="list__element list__element--numbered">
                  ausdrücklich zugestimmt hat, dass der Unternehmer mit der Vertragserfüllung vor
                  Ablauf der Widerrufsfrist beginnt und
                </li>
                <li class="list__element list__element--numbered">
                  seine Kenntnis davon bestätigt hat, dass durch seine Zustimmung mit Beginn der
                  Vertragserfüllung sein Widerrufsrecht erlischt und
                </li>
                <li class="list__element list__element--numbered">
                  der Unternehmer dem Verbraucher eine Bestätigung des Vertrags, innerhalb einer
                  angemessenen Frist nach Vertragsschluss, spätestens jedoch bei Bereitstellung der
                  nicht auf einem körperlichen Datenträger befindlichen digitalen Inhalte, auf einem
                  dauerhaften Datenträger zur Verfügung gestellt hat:
                  <ul class="list">
                    <li class="list__element list__element--alpha">
                      in der der Vertragsinhalt wiedergegeben ist und
                    </li>
                    <li class="list__element list__element--alpha">
                      auf der festgehalten ist, dass der Verbraucher vor Vertragserfüllung
                      ausdrücklich zugestimmt hat, dass der Unternehmer mit der Vertragserfüllung
                      vor Ablauf der Widerrufsfrist beginnt, und seine Kenntnis davon bestätigt hat,
                      dass er durch seine Zustimmung mit Beginn der Vertragserfüllung sein
                      Widerrufsrecht verliert.
                    </li>
                  </ul>
                </li>
              </ul>
              <br /><br />
              <h3 class="text text--center text--bold text--h5">Ende der Widerrufsbelehrung</h3>
            </div>
            <Heading
              tag="h4"
              size="sm"
              spaces-bottom
            >
              Widerrufsformular
            </Heading>
            <Paragraph>
              Falls Du von Deinem Widerrufsrecht Gebrauch machen wollen, kannst Du hierzu unser
              Retouren Formular (<a
                href="https://service.brodos.net/retoure"
                class="link link--external"
                title="Brodos Retoure"
                target="_blank"
                rel="noopener"
                data-tealium-rel="content.text.brodos-retoure"
                >https://service.brodos.net/retoure</a
              >) nutzen. In diesem Fall erhältst Du ein vorfrankiertes Rücksende-Etikett für die
              Rücksendung Deiner Ware. <br /><br />Wenn Du das Retouren Formular für Deinen Widerruf
              nicht nutzen möchtest, kannst Du uns auch in anderer Form kontaktieren und
              beispielsweise mithilfe dieses Formulars Deinen Widerruf erklären. In diesem Fall
              füllst Du bitte dieses Formular aus und sendest es zurück.<br /><br />An :<br />Brodos
              AG<br />Erlanger Straße 9-13<br />D-91083 Baiersdorf<br />E-Mail
              <a
                href="mailto:telekom-onlineshop-service@brodos.de"
                class="link"
                title="E-Mail an Telekom Onlineshop Service"
                >telekom-onlineshop-service@brodos.de</a
              ><br />Telefax 09133 47995-2000<br /><br />Hiermit widerrufe(n) ich/wir (*) den von
              mir/uns (*) abgeschlossenen Vertrag über den Kauf<br />
              der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)<br /><br />_____________________________________<br /><br />Bestellt
              am (*)/erhalten am (*)<br /><br />________________________<br /><br />Name des/der
              Verbraucher(s)<br /><br />_____________________________________________________<br /><br />Anschrift
              des/der Verbraucher(s)<br /><br />_____________________________________________________<br /><br />Unterschrift
              des/der Verbraucher(s) (nur bei Mitteilung auf Papier)<br /><br />__________________<br /><br />Datum<br /><br />__________________<br />(*)
              Unzutreffendes streichen.<br /><br />Das Widerrufsrecht besteht nicht bei folgenden
              Verträgen:<br /><br />• Verträge zur Lieferung von Waren, die nicht vorgefertigt sind
              und für deren Herstellung eine individuelle Auswahl oder Bestimmung durch den
              Verbraucher maßgeblich ist oder die eindeutig auf die persönlichen Bedürfnisse des
              Verbrauchers zugeschnitten sind,<br /><br />• Verträge zur Lieferung versiegelter
              Waren, die aus Gründen des Gesundheitsschutzes oder der Hygiene nicht zur Rückgabe
              geeignet sind, wenn ihre Versiegelung nach der Lieferung entfernt wurde,<br /><br />•
              Verträge zur Lieferung von Waren, wenn diese nach der Lieferung auf Grund ihrer
              Beschaffenheit untrennbar mit anderen Gütern vermischt wurden,<br /><br />• Verträge
              zur Lieferung von Ton- oder Videoaufnahmen oder Computersoftware in einer versiegelten
              Packung, wenn die Versiegelung nach der Lieferung entfernt wurde,<br /><br />•
              Verträge zur Lieferung von Zeitungen, Zeitschriften oder Illustrierten mit Ausnahme
              von Abonnement-Verträgen,<br /><br />• Verträge, bei denen der Verbraucher den
              Unternehmer ausdrücklich aufgefordert hat, ihn aufzusuchen, um dringende Reparatur-
              oder Instandhaltungsarbeiten vorzunehmen; dies gilt nicht hinsichtlich weiterer bei
              dem Besuch erbrachter Dienstleistungen, die der Verbraucher nicht ausdrücklich
              verlangt hat, oder hinsichtlich solcher bei dem Besuch gelieferter Waren, die bei der
              Instandhaltung oder Reparatur nicht unbedingt als Ersatzteile benötigt werden.
            </Paragraph>
          </div>
        </div>
      </template>
    </GridContainer>
  </main>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import SingleLevelBreadcrumb from '@/components/single-level-breadcrumb.vue';
import { GridContainer, Heading, Paragraph } from '@i22-td-smarthome/component-library';
import { Track } from '~/helpers/page-tracking';
import { getHeader } from '~/helpers/page-header-compositon';

Track();

getHeader({
  title: ref('Allgemeine Geschäftsbedingungen'),
  description: ref(
    'Allgemeine Geschäftsbedingungen der Brodos AG für den Onlineshop www.shop.telekom.de'
  ),
});

const paragraphs = [
  {
    headline: '§ 1 Geltungsbereich',
    text: "Diese Allgemeinen Geschäftsbedingungen (im Folgenden: 'AGB') regeln den Vertragsabschluss für Bestellungen über den Onlineshop auf der Seite www.shop.telekom.de. Die Angebote richten sich ausschließlich an Verbraucher im Sinne des § 13 BGB. Vertragssprache ist deutsch. Andere Sprachen stehen nicht zur Verfügung.",
  },
  {
    headline: '§ 2 Vertragspartner und Vertragsschluss',
    text: 'Vertragspartner des Kunden ist die Brodos AG, Erlanger Straße 9-13, 91083 Baiersdorf.<br /><br /> Die Präsentation der Waren im Onlineshop stellt kein rechtlich bindendes Vertragsangebot unsererseits dar, sondern ist nur eine unverbindliche Aufforderungen an Dich, Ware bei uns zu bestellen. Mit der Bestellung der gewünschten Ware gibst Du ein verbindliches Angebot auf Abschluss eines Kaufvertrages ab.<br /><br />Nachdem Du im Onlineshop die Bestellung unter Eingabe der dort relevanten Angaben durchlaufen hast, erfolgt die verbindliche Bestellung durch Anklicken des Buttons „Zahlungspflichtig bestellen“. Deine beim Bestellprozess angegebenen Daten kannst Du bis zum Abschluss des Bestellvorgangs jederzeit ändern.<br /><br />Den Eingang Deiner Bestellung bestätigen wir unmittelbar durch eine automatisch generierte E-Mail. Diese automatische Empfangsbestätigung dokumentiert lediglich, dass Deine Bestellung bei uns eingegangen ist und stellt keine Annahme des Antrags dar. Die Annahme des Angebots erfolgt durch eine Versandbestätigung spätestens jedoch durch den Versand der bestellten Ware innerhalb von einer Woche. Nach fruchtlosem Ablauf der Frist gilt das Angebot als abgelehnt.<br /><br />Dem Kunden stehen die beim Abschluss des Bestellprozesses angezeigten Zahlarten zur Verfügung.<br /><br />Wir speichern den Vertragstext mit Angaben zum gekauften Artikel auf unseren Systemen, die für Dich nicht zugänglich sind. Du kannst die Bestelldaten jedoch unmittelbar vor dem Abschicken über die Funktion Deines Browsers speichern und ausdrucken.',
  },
  {
    headline: '§ 3 Gesetzliches Widerrufsrecht',
    text: 'Bei Vertragsabschlüssen über unseren Onlineshop hast Du als Verbraucher das Recht den Kaufvertrag zu widerrufen. Wobei Verbraucher jede natürliche Person ist, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können:<br /><br />',
  },
  {
    headline: '§4 Warenpreise, Versandkosten ',
    text: 'Sämtliche Preise verstehen sich inklusive gesetzlicher Mehrwertsteuer und zuzüglich etwaiger Versandkosten. Über die Höhe der Versandkosten wirst Du im Rahmen des Bestellvorgangs informiert. Für die im Online-Shop bestellte Ware gelten die Preise des Tages der Bestellung. Du wirst im Rahmen des Bestellvorgangs explizit angegeben. Bei Zahlung per Kreditkarte erfolgt die Belastung bei Abschluss der Bestellung. Es gelten die Versandbedingungen des jeweiligen Paketdienstleisters.',
  },
  {
    headline: '§5 Eigentumsvorbehalt',
    text: 'Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum.',
  },
  {
    headline: '§6 Lieferung',
    text: 'Sind wir ohne eigenes Verschulden zur Lieferung der bestellten Ware nicht in der Lage, weil der Vorlieferant seine vertraglichen Verpflichtungen nicht erfüllt hat, oder ist die Deinerseits bestellte Ware für einen Zeitraum von mindestens einem Monat wegen höherer Gewalt nicht verfügbar, können wir vom Kaufvertrag zurücktreten. Wir werden Dich im Falle entsprechender Lieferschwierigkeiten unverzüglich informieren. Im Falle eines Rücktritts nach Maßgabe dieses Absatzes werden wir Dir bereits geleistete Zahlungen unverzüglich erstatten. Deine gesetzlichen Ansprüche bleiben im Übrigen unberührt. <br />Der Verkauf der von uns angebotenen Waren erfolgt nur in handelsüblichen Mengen.',
  },
  {
    headline: '§7 Gewährleistung',
    text: 'Es gilt die gesetzliche Gewährleistung.',
  },
  {
    headline: '§8 Haftung',
    text: '(1) Wir haften nach den gesetzlichen Bestimmungen, soweit eine Haftung nicht nach folgenden Bestimmungen ausgeschlossen ist.<br /><br />(2) Wir schließen unsere Haftung für leicht fahrlässige Pflichtverletzungen aus, sofern nicht Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit oder Garantien oder Ansprüche nach dem Produkthaftungsgesetz betroffen sind. Unberührt bleibt ferner die Haftung für die Verletzung von Pflichten, deren Erfüllung die ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und auf deren Einhaltung Du regelmäßig vertrauen darfst (vertragswesentliche Pflichten).<br /><br />(3) Die Regelungen aus diesem Paragraphen gelten auch für Pflichtverletzungen unserer Erfüllungsgehilfen.<br /><br />(4) Die Datenkommunikation über das Internet kann nach dem derzeitigen Stand der Technik nicht fehlerfrei und/oder jederzeit verfügbar gewährleistet werden. Wir haften insoweit nicht für die ständige und ununterbrochene Verfügbarkeit unseres Online-Shops.',
  },
  {
    headline: '§9 Schlussbestimmungen',
    text: "Es findet, soweit zulässig,  das Recht der Bundesrepublik  Deutschland unter Ausschluss des UN Kaufrechts Anwendung.<br /><br />Der Vertrag bleibt auch bei rechtlicher Unwirksamkeit einzelner Punkte in seinen übrigen Teilen verbindlich. An die Stelle der unwirksamen Punkte treten, soweit vorhanden, die gesetzlichen Vorschriften.<br /><br />Du hast die Möglichkeit, diese Allgemeinen Geschäftsbedingungen im Rahmen des Bestellvorgangs einzusehen, zu speichern und auszudrucken.<br /><br /><h3 class='text--bold text--h5'>Hinweis zur Streitschlichtung</h3><br/>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Du unter <a href='http://ec.europa.eu/consumers/odr/' class='link link--external' title='Europäische Kommission Online-Streitbeilegung' target='_blank' rel='noopener' data-tealium-rel='content.text.online-streitschlichtung'>http://ec.europa.eu/consumers/odr/</a> findest.<br /><br />Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor Verbraucherschlichtungsstellen teilzunehmen.",
  },
];
</script>
